import { ConsultationRequestError } from '@errors/consultation-request-error';

export class ConsultationRequestFormAlreadySubmittedError extends ConsultationRequestError {
  public constructor(contact: string) {
    super(`This form has already been submitted. Please contact customer service at ${contact} for assistance.`);
  }
}
